import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 73 59" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x="1" y="1" width="71" height="12" rx="6" fill="#ffffff00" stroke="#011056" strokeWidth="3" /><rect x="1" y="23" width="71" height="12" rx="6" fill="#ffffff00" stroke="#011056" strokeWidth="3" /><rect x="1" y="46" width="71" height="12" rx="6" fill="#ffffff00" stroke="#011056" strokeWidth="3" /></svg>);